/*
 * <cart-fiscal-fields>
 * Campos opcionales de facturación electrónica (Monte).
 * Guarda CC/NIT y correo como cart attributes vía /cart/update.js,
 * siguiendo el mismo patrón que <cart-note> de Dawn para que los valores
 * sobrevivan al re-render completo del cart drawer.
 */
if (!customElements.get('cart-fiscal-fields')) {
  customElements.define(
    'cart-fiscal-fields',
    class CartFiscalFields extends HTMLElement {
      constructor() {
        super();
        this.debounceTimer = null;
      }

      connectedCallback() {
        this.inputs = Array.from(this.querySelectorAll('input[name^="attributes["]'));
        this.inputs.forEach((input) => {
          input.addEventListener('input', () => this.onInput());
          // change dispara en blur: si el cliente hace clic en "Pagar",
          // el input pierde foco y se guarda de inmediato (sin esperar el debounce).
          input.addEventListener('change', () => this.save());
        });
      }

      onInput() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => this.save(), 500);
      }

      save() {
        clearTimeout(this.debounceTimer);
        if (!this.inputs || !window.routes || !routes.cart_update_url) return;

        const attributes = {};
        this.inputs.forEach((input) => {
          const match = input.name.match(/^attributes\[(.+)\]$/);
          if (match) attributes[match[1]] = input.value.trim();
        });

        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig()
            : {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              };

        fetch(`${routes.cart_update_url}`, { ...config, body: JSON.stringify({ attributes }) }).catch(() => {});
      }
    }
  );
}
